/*
  Use this controller to auto-submit a form when the adorned element is changed,
  but with a "debounce" delay to prevent submitting too often.

  The default delay is 500ms, but you can customize it by adding a data-wait attribute.

  Example:
  <form>
    <textarea data-controller="debounce-submit" data-wait="200"></textarea>
  </form>
*/
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("change", this.onChange.bind(this));
    this.element.addEventListener("keyup", this.onChange.bind(this));
    this.timeout = null;
    this.wait = parseInt(this.element.getAttribute("data-wait") || 500);
  }

  onChange(e) {
    // Submit the form to save the changes, but don't submit too often (debounce).
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      // console.log("submitting form");
      this.element.form.requestSubmit();
    }, this.wait);
  }
}